import { defineComponent as r, computed as l, openBlock as c, createElementBlock as s, createElementVNode as t, toDisplayString as d, createCommentVNode as n, normalizeStyle as p, createStaticVNode as v } from "vue";
const f = ["viewBox"], _ = /* @__PURE__ */ t("mask", { id: "46274ac1-f6c8-4030-9938-454b0d4c13c1" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#46274ac1-f6c8-4030-9938-454b0d4c13c1)" }, k = { key: 0 }, u = /* @__PURE__ */ v('<path fill="#0052b4" d="m0 160 256-32 256 32v192l-256 32L0 352z"></path><path fill="#eee" d="M0 0h512v160H0z"></path><path fill="#d80027" d="M0 352h512v160H0z"></path><path fill="#eee" d="M64 63v217c0 104 144 137 144 137s144-33 144-137V63z"></path><path fill="#d80027" d="M96 95v185a83 78 0 0 0 9 34h206a83 77 0 0 0 9-34V95z"></path><path fill="#eee" d="M288 224h-64v-32h32v-32h-32v-32h-32v32h-32v32h32v32h-64v32h64v32h32v-32h64z"></path><path fill="#0052b4" d="M152 359a247 231 0 0 0 56 24c12-3 34-11 56-24a123 115 0 0 0 47-45 60 56 0 0 0-34-10l-14 2a60 56 0 0 0-110 0 60 56 0 0 0-14-2c-12 0-24 4-34 10a123 115 0 0 0 47 45z"></path>', 7), g = { fill: "none" }, z = ["r"], M = /* @__PURE__ */ r({
  __name: "sk",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(h) {
    const e = h, o = l(() => 512 + 2 * e.strokeWidth), a = l(() => -e.strokeWidth), i = l(() => 256 + e.strokeWidth / 2);
    return (x, w) => (c(), s("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${o.value} ${o.value}`
    }, [
      _,
      t("g", m, [
        e.flagName ? (c(), s("title", k, d(e.flagName), 1)) : n("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: i.value,
          fill: "none",
          style: p({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, z)
      ])
    ], 8, f));
  }
});
export {
  M as default
};
//# sourceMappingURL=sk-413cfecb.js.map
